module.exports = __webpack_public_path__ + "img/5ix.5f7bd9e9.jpg";